import * as angular from "angular";
import { DynamicReportService } from "../../../main/components/reports/_services/dynamicReports.service";
import { IReportDefinition } from "../../../main/components/reports/models/IReportDefinition";

export interface IReportNameValidatorScope extends angular.IScope {
    reportNameValidator: number;
    reports: IReportDefinition[];
}

export class ReportNameValidator implements angular.IDirective {

    restrict = 'A';
    require = 'ngModel';
    scope = { reportNameValidator: "<", reports: "<" }

    static $inject = ['$q', '$window', 'dynamicReportService'];

    constructor(
        private $q: angular.IQService,
        private $window: angular.IWindowService,
        private reportService: DynamicReportService) {
    }

    link(scope: IReportNameValidatorScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        ngModel.$asyncValidators["reportName"] = modelValue => {
            if (scope.reports) {
                var foundMatch = false;

                scope.reports.forEach(report => {
                    if (report.Id === scope.reportNameValidator) {
                        return;
                    }
                    if (report.Title === modelValue) {
                        foundMatch = true;
                    }
                });

                if (foundMatch) {
                    return this.$q.reject("Report name is already in use.");
                }
            }

            return this.reportService.reportNameExists(modelValue, scope.reportNameValidator).then(result => {
                if (result) {
                    return this.$q.reject("Report name is already in use.");
                }
                return this.$q.resolve();
            });
        };
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($q: angular.IQService, $window: angular.IWindowService, reportService: DynamicReportService) => new ReportNameValidator($q, $window, reportService);
        directive.$inject = ['$q', '$window', 'dynamicReportService'];
        return directive;
    }
}
